import type { FaireProductEntity } from "../../entity_types/product";

export const p_zz6bmwxhng: FaireProductEntity = {
  token: "p_zz6bmwxhng",
  type: "product",
  name: "Arkansas Razorbacks Hogs Mono Puff Ink Red Heavyweight Tee",
  brandToken: "b_1bf5q9xdtj",
  brandName: "LivyLu",
  imageUrl: "https://cdn.faire.com/fastly/e2bfd6a94e01f57016293b8d98470db20e4365fc0df00e974a72ebcfeb4ceedb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/60ca2f2df34d860b92baa7b4904126093592ec77d49dba6f6e2e5e9b7eaac740.jpeg",
    "https://cdn.faire.com/fastly/cef4335ac116f5cf040d5b1e417be29f269f76d4fb1dc4a8c730a83129c3972c.jpeg",
    "https://cdn.faire.com/fastly/b5b775b27da20bfe7d5f555eeef02dbe0b6680edb88a9b479343bde0c21cc9ce.jpeg"
  ],
  priceDollars: 22,
  description: "Wooo Pig Sooie!!!  Show off your University of Arkansas Razorbacks Hog Spirit with this tee that is perfect for Game Day or Any Day! \n\n6 oz. (US), 10 oz./L yd (CA), 100% Airlume combed and ring-spun cotton, 20 singles\nAthletic Heather is 90/10 Airlume combed and ring-spun cotton/polyester\nHeavyweight\nPre-shrunk\nRelaxed fit\nDrop shoulder\nDouble-needle stitched neck\nSide seams\nTear away label\nOfficially Licensed\n\nBody Length:\nXS - 26 1/4\"\nS - 27 1/4\"\nM - 27 3/4\"\nL - 28 3/4\"\nXL - 29 3/4\"\n2XL - 30 1/4\"\n\nChest Width (Laid Flat):\nXS - 18 3/4\"\nS - 19 3/4\"\nM - 20 3/4\"\nL - 22 3/4\"\nXL - 24 3/4\"\n2XL - 26 3/4\"\n",
  tags: [],
  msrpDollars: 44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:24:23.418Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
